import { SET_COMPANY_LIST, SET_UPDATED_COMPANY_LIST, SET_BILLING_PLAN } from "../../constants/actionTypes";

const company = (state = {}, action) => {
  switch (action.type) {
    case SET_COMPANY_LIST:
      return {
        ...state,
        companyList: action.companyList
      };
    case SET_UPDATED_COMPANY_LIST:
      return {
        ...state,
        updatedCompanyList: action.updatedCompanyList
      };
    case SET_BILLING_PLAN:
      return {
        ...state,
        billingPlan: action.billingPlan
      };
    default:
      return state;
  }
};

export default company;
